import Typed from 'typed.js';

const DEFAULT_OPTIONS = {
  loop: true
};

export default function typewriter({ element, options }) {
  return new Typed(element, { ...DEFAULT_OPTIONS, ...options });
}
